import React from 'react';
import { brandGradients, brandTextGradients } from '../theme/palette';

const Vision = () => {
  const visionPoints = [
    {
      icon: 'fas fa-search',
      title: 'Comprehensive Verification Solutions',
      description: 'Provide all kinds of verification solutions with complete professionalism and accuracy.'
    },
    {
      icon: 'fas fa-handshake',
      title: 'Long-term Client Relationships',
      description: 'Develop fruitful and lasting relationships with our clients based on trust and reliability.'
    },
    {
      icon: 'fas fa-users',
      title: 'Employee Empowerment',
      description: 'Our employees are our greatest assets. We empower them to grow professionally and personally.'
    },
    {
      icon: 'fas fa-expand-arrows-alt',
      title: 'South India Expansion',
      description: 'Establish our branch services throughout South India with excellent work environment.'
    }
  ];

  return (
    <section id="vision" className="py-20 lg:py-16 bg-white">
  <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16 animate-on-scroll">
          <span className="text-[#00a4f4] text-xl font-bold" style={{ color: '#ff70a6' }}>
            Our Vision
          </span>
          <h2 className="text-4xl lg:text-6xl font-black text-gray-800 mt-4 mb-8 leading-tight">
            Building Trust Through
            <span className="block text-blue-600">Professional Excellence</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            We are committed to providing comprehensive verification solutions with complete focus on 
            professionalism, building lasting relationships, and empowering our team to deliver exceptional results.
          </p>
        </div>

        {/* Vision Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {visionPoints.map((point, index) => (
            <div 
              key={index} 
              className="group p-8 bg-gradient-to-br from-white to-blue-50 rounded-2xl shadow-1xl hover:shadow-1xl transition-all duration-500 animate-on-scroll border border-blue-100 hover:border-blue-200"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="text-center">
                <div className="w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg" style={{ background: brandGradients.panel }}>
                  <i className={`${point.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4 group-hover:text-blue-600 transition-colors duration-300">
                  {point.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {point.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Vision;